module.exports = __webpack_public_path__ + "static/media/ASPNetIcon.4bdf8e7d.svg";